import { styled } from '@mui/material/styles';
import { Typography } from '@raisin/components-lib';

// used color is not from palette because it's requested by spanish regulators
export const RiskBannerRating = styled('span')(({ theme }) => ({
  fontSize: theme.typography.h2.fontSize,
  fontWeight: theme.typography.subtitle1.fontWeight,
  lineHeight: theme.typography.h2.lineHeight,
  color: theme.palette.black80.main,
  letterSpacing: '-5pt',
}));

export const RiskBannerRatingNumenator = styled('span')({
  color: '#bdbdbd',
});

export const RiskBannerRatingContainer = styled('div')({
  width: '100%',
  textAlign: 'center',
});

export const RiskBannerSectionText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'mainSection',
})(({ theme, mainSection }) => ({
  paddingTop: mainSection ? theme.spacing(3) : 0,
  color: theme.palette.black80.main,
}));

export const RiskBannerLockIconSet = styled('span')({
  '& .MuiSvgIcon-fontSizeMedium': {
    width: 13,
    height: 13,
  },
});

export const RiskBannerContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'hasTerminationSection',
})(({ theme, hasTerminationSection }) => ({
  maxWidth: 600,
  margin: theme.spacing(6, 0),
  background: theme.palette.white.main,
  border: `1px solid ${theme.palette.black40.main}`,
  borderRadius: 6,
  outline: 'none',
  '> :nth-child(2)': {
    borderRight: hasTerminationSection ? `1px solid ${theme.palette.black40.main}` : '0',
  },
  [theme.breakpoints.up('md')]: {
    display: 'grid',
    gridTemplateColumns: hasTerminationSection ? '1fr 1fr 1fr' : '1fr 1fr',
  },
  [theme.breakpoints.down('md')]: {
    '> :nth-child(2)': {
      borderRight: 0,
      borderBottom: hasTerminationSection ? `1px solid ${theme.palette.black40.main}` : '0',
    },
  },
}));

export const RiskBannerMainSection = styled('div')(({ theme }) => ({
  padding: theme.spacing(3.75),
  [theme.breakpoints.up('md')]: {
    borderRight: `1px solid ${theme.palette.black40.main}`,
  },
  [theme.breakpoints.down('md')]: {
    borderBottom: `1px solid ${theme.palette.black40.main}`,
  },
}));

export const RiskBannerSection = styled('div', {
  shouldForwardProp: (prop) => prop !== 'earlyTerminationSection',
})(({ theme, earlyTerminationSection }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: earlyTerminationSection ? theme.spacing(6.25) : theme.spacing(10),
  padding: theme.spacing(3.75),
  background: theme.palette.white.main,
}));
